import { useState, useEffect } from "react";
import { useUserLogin, getSessionInfo, getSessionRoles } from "./UserLogin";

export function useUserInfo() {
    const [userInfo, , userObj] = useUserLogin();
    const [info, setInfo] = useState(getSessionInfo());
    const [roles, setRoles] = useState(getSessionRoles());

    useEffect(() => {
        if (!info || !roles)
            setInfo(userObj);
            setRoles(getSessionRoles)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo, info, userObj]);
    return info;
}